import { render } from "./TheNavbarUserMenu.pug?vue&type=template&id=2bb9a370&lang=pug"
import script from "./TheNavbarUserMenu.js?vue&type=script&lang=js"
export * from "./TheNavbarUserMenu.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__